﻿$.fn.dxCtrlWizardItem2ResaPanier = function custom_dxCtrlWizardItem2ResaPanier(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizarditem2resapanier dx-ctrl");
        this.createInstance(new cdxCtrlWizardItem2ResaPanier(this, option));
    }
    return this;
}

window.cdxCtrlWizardItem2ResaPanier = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        $("<div style='margin-top:20px;text-align:center;font-weight:bold;font-size:140%;'>Résumé de votre séjour</div>").appendTo(container)

        var $Table = $("<table style='width:calc(100% - 40px);margin:20px 20px 0 20px;'/>").appendTo(container)
        if (parametre.isPhone) $Table.css({ "width": "100%", margin: "10px 0" })

        option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetLstReservationHebergement().filter(function (o) {
            return o.id_reservation_hebergement_parent == null
        }).forEach(function (dataResaHeberg) {
            var objResaHeberg = option.bddCtrl.getObjet(dataResaHeberg)
            var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
            var $Td = $("<td style='width:100%;white-space:nowrap;padding:15px 5px 0 5px;position:relative;'/>").appendTo($Tr)

            $("<div style='font-weight:bold;'/>").appendTo($Td).html(objResaHeberg.objetMetier.mGetHebergement().nom)
            var $Div = $("<div style='position:absolute;right:0;top:15px;font-family:barlow condensed;opacity:0.6;'/>").appendTo($Td).html(objResaHeberg.objetMetier.mGetLibHtmlForResaInternet())
            if (parametre.isPhone) $Div.css({ "position": "", "right": "", "top": "" })
            //var $TableDetail = $("<table style='width:100%'/>").appendTo($Td)
            //var $TrDetail = $("<tr/>").appendTo($TableDetail)
            //var $TdDetail = $("<td style='width:1px;font-size:100%;font-weight:bold;white-space:nowrap;'/>").appendTo($TrDetail).html(objResaHeberg.objetMetier.mGetHebergement().nom)
            //if (parametre.isPhone) {
            //    $TdDetail.css("width", "100%")
            //    $TrDetail = $("<tr/>").appendTo($TableDetail)
            //}
            //var $TdDetail = $("<td style='width:100%;font-family:barlow condensed;opacity:0.6;text-align:right;'/>").appendTo($TrDetail).html(objResaHeberg.objetMetier.mGetLibHtmlForResaInternet())

            var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:15px 5px 0 5px;min-width:100px;'/>").appendTo($Tr).html(parseFloat(objResaHeberg.objetMetier.mGetTotalTtcNuite()).formatDisplay() + "€")
            var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:15px 5px 0 5px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                height: 16,
                width: 16,
                icon: "fas fa-xmark",
                hint: "Supprimer l'hébergement",
                onClick: function (e) {
                    jaugeDemarrage.mShow()
                    objResaHeberg.mDelDataDefinitif(function (data) {
                        jaugeDemarrage.mHide()
                        if (option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetLstReservationHebergement().length == 0) {
                            option.onPrevious()
                        } else {
                            mConstruit()
                        }
                    })
                }
            })

            var objHeberg = option.bddCtrl.getObjet("hebergement", dataResaHeberg.id_hebergement)
            if (objHeberg.data.is_virtuel == "1") {
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-family:barlow condensed;font-size:100%;' colspan='3'/>").appendTo($Tr)
                var $TableDefineHeberg = $("<table style='width:100%;text-align:left;'/>").appendTo($Td)
                var lstResaHebergChild = option.bddCtrl.getObjet(dataResaHeberg).objetMetier.mGetLstReservationHebergementLinkedForVirtuel()
                lstResaHebergChild.forEach(function (dataResaHebergChild) {
                    var $TrDefineHeberg = $("<tr/>").appendTo($TableDefineHeberg)
                    var dataHebergLinked = option.bddCtrl.getObjet(dataResaHebergChild).objetMetier.mGetHebergement()
                    var $Td = $("<td style='width:40%;line-height:1;'/>").appendTo($TrDefineHeberg).text(dataHebergLinked.nom)
                    var $Td = $("<td style='width:60%;white-space:nowrap;font-size:60%;'/>").appendTo($TrDefineHeberg)
                    $("<div/>").appendTo($Td).dxCtrlGetNbPersonne({
                        bddCtrl: option.bddCtrl,
                        dataHebergement: dataHebergLinked,
                        disabled: false,
                        width: 55,
                        value: {
                            nb_adulte: dataResaHebergChild.nb_adulte ?? 0,
                            nb_enfant: dataResaHebergChild.nb_enfant ?? 0
                        },
                        onValueChanged: function (e) {
                            dataResaHebergChild.nb_adulte = e.value.nb_adulte
                            dataResaHebergChild.nb_enfant = e.value.nb_enfant
                            dataResaHeberg.nb_adulte = 0
                            dataResaHeberg.nb_enfant = 0
                            lstResaHebergChild.forEach(function (dataResaHebergChildTt) {
                                dataResaHeberg.nb_adulte += dataResaHebergChildTt.nb_adulte
                                dataResaHeberg.nb_enfant += dataResaHebergChildTt.nb_enfant
                            })
                            var objs = option.bddCtrl.getObjets()
                            objs.mAddData([dataResaHebergChild, dataResaHeberg], "save")
                            objs.mSave(function () {
                                mConstruit()
                            })
                        }
                    })
                    var $Td = $("<td style='width:1px;height:1px;'/>").appendTo($TrDefineHeberg)
                    var lstHebergementConfig = option.bddCtrl.getObjet(dataHebergLinked).objetMetier.mGetLstHebergementConfig()
                    $("<div style='font-size:60%;width:" + (lstHebergementConfig.length * 60) + "px;display:inline-block;line-height:1;height:100%;'/>").appendTo($Td).dxCtrlRadioButton({
                        labelMode: 'floating',
                        label: "Config. hébergement",
                        dataSource: lstHebergementConfig,
                        value: lstHebergementConfig.filter(function (o) { return o.nb_grand_lit == dataResaHebergChild.nb_grand_lit && o.nb_petit_lit == dataResaHebergChild.nb_petit_lit })[0],
                        layout: 'horizontal',
                        itemTemplate: function (itemData, itemIndex, itemElement) {
                            $("<div/>").appendTo(itemElement).dxCtrlVisuHebergementConfig({
                                bddCtrl: option.bddCtrl,
                                value: itemData
                            })
                        },
                        onValueChanged: function (e) {
                            dataResaHebergChild.nb_grand_lit = e.value.nb_grand_lit
                            dataResaHebergChild.nb_petit_lit = e.value.nb_petit_lit
                            option.bddCtrl.getObjet(dataResaHebergChild).mSave(function (data) {
                            })
                        }
                    });
                })
                //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;min-width:100px;vertical-align:top;'/>").appendTo($Tr)
                //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;vertical-align:top;'/>").appendTo($Tr)
            } else {
                var lstHebergementConfig = objHeberg.objetMetier.mGetLstBestHebergementConfigWithAdulteEnfant(dataResaHeberg.nb_adulte, dataResaHeberg.nb_enfant)
                if (lstHebergementConfig.length > 1) {
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;text-align:right;font-family:barlow condensed;font-size:60%;'/>").appendTo($Tr)
                    $("<div style='font-size:60%;width:" + (lstHebergementConfig.length * 80) + "px;display:inline-block;line-height:1;'/>").appendTo($Td).dxCtrlRadioButton({
                        labelMode: 'floating',
                        label: "Choisir configuration hébergement",
                        dataSource: lstHebergementConfig,
                        value: lstHebergementConfig.filter(function (o) { return o.nb_grand_lit == dataResaHeberg.nb_grand_lit && o.nb_petit_lit == dataResaHeberg.nb_petit_lit })[0],
                        layout: 'horizontal',
                        itemTemplate: function (itemData, itemIndex, itemElement) {
                            $("<div style='font-size:140%;'/>").appendTo(itemElement).dxCtrlVisuHebergementConfig({
                                bddCtrl: option.bddCtrl,
                                value: itemData
                            })
                        },
                        onValueChanged: function (e) {
                            dataResaHeberg.nb_grand_lit = e.value.nb_grand_lit
                            dataResaHeberg.nb_petit_lit = e.value.nb_petit_lit
                            option.bddCtrl.getObjet(dataResaHeberg).mSave(function (data) {
                            })
                        }
                    });
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;min-width:100px;'/>").appendTo($Tr)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;'/>").appendTo($Tr)
                }
            }


            objResaHeberg.objetMetier.mGetLstDataReservationService().filter(function (dataResaService) {
                return dataResaService.rajout_automatique == 1
            }).forEach(function (dataResaService) {
                var objService = option.bddCtrl.getObjet(dataResaService)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;padding:5px 5px 5px 40px;position:relative;'/>").appendTo($Tr)

                $("<div/>").appendTo($Td).html(objService.objetMetier.mGetDataArticle().nom)
                $("<div style='position:absolute;right:0;top:5px;font-family:barlow condensed;opacity:0.6;'/>").appendTo($Td).html(objService.objetMetier.mGetLibQuantiteHtml() + " × " + objService.objetMetier.mGetLstDateNbReservationServiceActive().length + "<i class='fas fa-moon'></i>" + " × " + parseFloat(objService.data.puttc).formatDisplay() + "€")
                //var $TableDetail = $("<table style='width:100%'/>").appendTo($Td)
                //var $TrDetail = $("<tr/>").appendTo($TableDetail)
                //var $TdDetail = $("<td style='width:1px;font-size:100%;font-weight:bold;white-space:nowrap;'/>").appendTo($TrDetail).text(objService.objetMetier.mGetDataArticle().nom)
                //if (parametre.isPhone) {
                //    $TdDetail.css("width", "100%")
                //    $TrDetail = $("<tr/>").appendTo($TableDetail)
                //}
                //var $TdDetail = $("<td style='width:100%;font-family:barlow condensed;opacity:0.6;text-align:right;'/>").appendTo($TrDetail).html(objService.objetMetier.mGetLibQuantiteHtml() + " × " + objService.objetMetier.mGetLstDateNbReservationServiceActive().length + "<i class='fas fa-moon'></i>" + " × " + parseFloat(objService.data.puttc).formatDisplay() + "€")

                var $Td = $("<td style='width:1px;text-align:right;padding:5px;min-width:100px;'/>").appendTo($Tr).html(parseFloat(objService.objetMetier.mGetTotTtc()).formatDisplay() + "€")
                var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;'/>").appendTo($Tr)
            })

            objResaHeberg.objetMetier.mGetLstDataReservationService().filter(function (dataResaService) {
                return dataResaService.rajout_automatique == 0
            }).forEach(function (dataResaService) {
                var objService = option.bddCtrl.getObjet(dataResaService)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;padding:5px 5px 5px 40px;vertical-align:top;position:relative;i'/>").appendTo($Tr)

                $("<div/>").appendTo($Td).html(objService.objetMetier.mGetDataArticle().nom)
                var txtLibDate = ""
                var lstGrpDateNbResaService = option.bddCtrl.getObjet(dataResaService).objetMetier.mGetLstGrpDateNbReservationService()
                if (lstGrpDateNbResaService.length > 0) {
                    lstGrpDateNbResaService.forEach(function (objGrpDateNbResaService) {
                        txtLibDate += (txtLibDate.length > 0 ? "<span> &bull; </span>" : "")
                        txtLibDate += objGrpDateNbResaService.mGetLibHtmlDate()// + " = " + parseFloat(objGrpDateNbResaService.mGetTotTtc()).formatDisplay() + "€"
                    })
                }
                $("<div style='position:absolute;right:0;top:5px;font-family:barlow condensed;opacity:0.6;'/>").appendTo($Td).html((txtLibDate.length > 0 ? "(" : "") + txtLibDate + (txtLibDate.length > 0 ? ") <span> &bull; </span>" : "") + objService.objetMetier.mGetLstDateNbReservationServiceActive().length + "<i class='fas fa-moon'></i>" + " × " + objService.objetMetier.mGetLibQuantiteHtml() + " × " + parseFloat(objService.data.puttc).formatDisplay() + "€")
                //var $TableDetail = $("<table style='width:100%'/>").appendTo($Td)
                //var $TrDetail = $("<tr/>").appendTo($TableDetail)
                //var $TdDetail = $("<td style='width:1px;font-size:100%;font-weight:bold;white-space:nowrap;'/>").appendTo($TrDetail).text(objService.objetMetier.mGetDataArticle().nom)
                //if (parametre.isPhone) {
                //    $TdDetail.css("width", "100%")
                //    $TrDetail = $("<tr/>").appendTo($TableDetail)
                //}
                //var txtLibDate = ""
                //var lstGrpDateNbResaService = option.bddCtrl.getObjet(dataResaService).objetMetier.mGetLstGrpDateNbReservationService()
                //if (lstGrpDateNbResaService.length > 0) {
                //    lstGrpDateNbResaService.forEach(function (objGrpDateNbResaService) {
                //        txtLibDate += (txtLibDate.length > 0 ? "<span> &bull; </span>" : "")
                //        txtLibDate += objGrpDateNbResaService.mGetLibHtmlDate()// + " = " + parseFloat(objGrpDateNbResaService.mGetTotTtc()).formatDisplay() + "€"
                //    })
                //}
                //var $TdDetail = $("<td style='width:100%;font-family:barlow condensed;opacity:0.6;text-align:right;'/>").appendTo($TrDetail).html((txtLibDate.length > 0 ? "(" : "") + txtLibDate + (txtLibDate.length > 0 ? ") <span> &bull; </span>" : "") + objService.objetMetier.mGetLstDateNbReservationServiceActive().length + "<i class='fas fa-moon'></i>" + " × " + objService.objetMetier.mGetLibQuantiteHtml() + " × " + parseFloat(objService.data.puttc).formatDisplay() + "€")

                var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;min-width:100px;'/>").appendTo($Tr).html(parseFloat(objService.objetMetier.mGetTotTtc()).formatDisplay() + "€")

                var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    height: 16,
                    width: 16,
                    icon: "fas fa-xmark",
                    hint: "Supprimer le service",
                    onClick: function (e) {
                        jaugeDemarrage.mShow()
                        objService.mDelDataDefinitif(function (data) {
                            jaugeDemarrage.mHide()
                            mConstruit()
                        })
                    }
                })
            })

            //dcr            : Mon May 11 2026 19: 37: 56 GMT +0200(heure d’été d’Europe centrale) { }
            //dmo            : Mon May 11 2026 19: 37: 56 GMT +0200(heure d’été d’Europe centrale) { }
            //id_article            :            806
            //id_historique_sup            :            null
            //id_reservation            :            null
            //id_reservation_hebergement            :            null
            //id_reservation_service            :            "caf63bd1-3f9b-4e6a-acf2-1bbc3682b1ed"
            //id_type_iteration_service            :            0
            //id_type_plage_service            :            0
            //id_type_quantite            :            "3"
            //id_utilisateur            :            null
            //puttc            :            0
            //qte            :            0
            //reservation_service_date            :            []
            //text_link            :            "Ajouter des Repas"
            if (option.bddCtrl.paraAppli.mGetPara("hebergement_reservation_service_sur_internet_optionel").length > 0) {
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;text-align:right;padding:5px 5px 5px 40px;font-family:barlow condensed;'/>").appendTo($Tr)
                option.bddCtrl.paraAppli.mGetPara("hebergement_reservation_service_sur_internet_optionel").forEach(function (dataOpt, idx) {
                    if (idx > 0) $("<span> &bull; </span>").appendTo($Td)
                    $A = $("<a href='javascript:void(0)'>" + dataOpt.text_link + "</a>").appendTo($Td)
                    $A.on("click", function (e) {
                        jaugeDemarrage.mShow()
                        option.bddCtrl.getObjet("reservation_service").objetMetier.mCreateNewService(dataOpt.id_article, null, dataResaHeberg,
                            function (dataReservationService) {
                                dataReservationService.id_reservation = option.dataForResa.dataReservation.id_reservation
                                dataReservationService.id_type_iteration_service = dataOpt.id_type_iteration_service
                                dataReservationService.id_type_quantite = dataOpt.id_type_quantite
                                if (dataOpt.puttc > 0) dataReservationService.puttc = dataOpt.puttc
                                if (dataOpt.id_type_quantite == 0) { dataReservationService.qte = dataOpt.qte }
                                option.bddCtrl.getObjet(dataReservationService).mSave(function (data) {
                                    switch (parseInt(dataReservationService.id_type_iteration_service)) {
                                        case 0: //tous les jours sans choix de date
                                            jaugeDemarrage.mHide()
                                            mConstruit()
                                            break;
                                        case 1://choix de date
                                            var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                                height: "auto",
                                                width: 400,
                                                showMaximize: false,
                                                title: "Choisissez les jours de service",
                                                contentTemplate: function (contentElement) {
                                                    var $DivLst = $("<div/>").appendTo(contentElement)
                                                    mRempli()
                                                    function mRempli() {
                                                        var dataSource = []
                                                        var value = []
                                                        var lstSelected = option.bddCtrl.getObjet(dataReservationService).objetMetier.mGetLstJourneesServiceSelected()
                                                        option.bddCtrl.getObjet(dataReservationService).objetMetier.mGetLstDateNbReservationService().forEach(function (ele) {
                                                            dataSource.push(ele.date)
                                                            if (lstSelected.filter(function (o2) { return ele.date.toDDMMAA() == o2.toDDMMAA() }).length > 0) value.push(ele.date)
                                                        })

                                                        $DivLst.css("height", $DivLst.innerHeight() + "px")
                                                        $DivLst.empty()
                                                        var dxCheckBoxTout = $("<div style='barlow'/>").appendTo($DivLst).dxCheckBox({
                                                            text: "Tous les jours",
                                                            value: lstSelected.length == dataSource.length,
                                                            onValueChanged: function (e) {
                                                                if (e.value) {
                                                                    lstSelected = dataSource
                                                                } else {
                                                                    lstSelected = []
                                                                }
                                                                dxCheckBoxTout.option("disabled", true)
                                                                dxLstJour.isDisabledAll(true)
                                                                option.bddCtrl.getObjet(dataReservationService).objetMetier.mUpdateResaServiceDate(lstSelected, function () {
                                                                    mRempli()
                                                                }, function () {
                                                                    dxLstJour.isDisabledAll(false)
                                                                    dxCheckBoxTout.option("disabled", false)
                                                                })
                                                                mRempli()
                                                            }
                                                        }).dxCheckBox("instance")
                                                        var dxLstJour = $("<div style='width:100%;border-left:" + theme.border + ";border-right:" + theme.border + ";border-bottom:" + theme.border + ";'/>").appendTo($DivLst).dxCtrlLstCheckBox({
                                                            label: "Sélectionnez les jours du service",
                                                            labelMode: 'floating',
                                                            noDataText: "(Aucune journées disponible)",
                                                            placeholder: "",
                                                            layout: "horizontal",
                                                            maxWidth: 80,
                                                            dataSource: dataSource,
                                                            value: value,
                                                            itemTemplate: function (itemData, itemElement) {
                                                                itemElement.css("font-family", "barlow condensed")
                                                                itemElement.text(itemData.dayOfWeekName() + " " + itemData.toDDMM())
                                                            },
                                                            isEgale: function (d1, d2) { return d1.toDDMMAA() == d2.toDDMMAA() },
                                                            onValueChanged: function (e) {
                                                                lstSelected = e.value;
                                                                dxCheckBoxTout.option("disabled", true)
                                                                dxLstJour.isDisabledAll(true)
                                                                option.bddCtrl.getObjet(dataReservationService).objetMetier.mUpdateResaServiceDate(e.value, function () {
                                                                    mRempli()
                                                                }, function () {
                                                                    dxLstJour.isDisabledAll(false)
                                                                    dxCheckBoxTout.option("disabled", false)
                                                                })
                                                            },
                                                            onContentReady: function (e) {
                                                                e.element().find(".dx-placeholder").css("font-family", "barlow condensed")
                                                            }
                                                        }).dxCtrlLstCheckBox("instance")
                                                        $DivLst.css("height", "")
                                                    }

                                                    $("<div style='display:inline-block'/>").appendTo($("<div style='text-align:right'/>").appendTo(contentElement)).dxCtrlButton({
                                                        text: "Valider",
                                                        onClick: function (e) {
                                                            pop.hide()
                                                        }
                                                    })
                                                },
                                                onHiding: function (e) {
                                                    mConstruit()
                                                }
                                            }).dxCtrlPopupBase("instance")
                                            pop.show()
                                            jaugeDemarrage.mHide()
                                            break;
                                    }
                                })
                            })
                    })
                })
                var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;min-width:100px;'/>").appendTo($Tr)
                var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;'/>").appendTo($Tr)
            }

        })

        var objResa = option.bddCtrl.getObjet(option.dataForResa.dataReservation)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;text-align:right;padding:5px 5px 5px 40px;'>Total TTC:</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;min-width:100px;font-weight:bold;font-size:140%;'/>").appendTo($Tr).html(parseFloat(objResa.objetMetier.mGetTotalTtc()).formatDisplay() + "€")
        var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding:5px;'/>").appendTo($Tr)

        $("<div style='border:" + theme.border + ";border-radius:5px;margin:30px;padding:5px;'/>").appendTo(container).dxTextArea({
            labelMode: "floating",
            label: "Précisez les choses qui vous paraisse importante pour votre séjour",
            value: (option.dataForResa.dataReservation.commentaire_destinataire ? option.dataForResa.dataReservation.commentaire_destinataire : ""),
            onValueChanged: function (e) {
                option.dataForResa.dataReservation.commentaire_destinataire = (e.value ? e.value : "")
                option.bddCtrl.getObjet(option.dataForResa.dataReservation).mSaveChamp("commentaire_destinataire")
            }
        })


        var $Table = $("<table style='width:calc(100% - 40px);margin:20px 20px 0 20px;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $AAddHeberg = $("<a href='javascript:void(0)'>← Ajouter un hébergement</a>").appendTo($Td)
        $AAddHeberg.on("click", function (e) {
            option.onPrevious()
        })
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var $AAddHeberg = $("<a href='javascript:void(0)'>Vos coordonnées →</a>").appendTo($Td)
        $AAddHeberg.on("click", function (e) {
            option.onNext()
        })
    }


    this.mIsActivated = function () {
        mConstruit()
    }

    this.isOkForNext = function (dxScroll) {
        var okForNext = true

        return okForNext
    }

    this.mGetClassIconeForLstItem = function () {
        return "fas fa-cart-shopping"
    }
    this.hasHeight100Percent = function () { return true }
    this.title = function () { return "Votre panier" }
    this.mGetProprieteImage = function () {
        var urlFond = ""
        var lstImage = JSON.parse(option.bddCtrl.paraAppli.mGetPara("hebergement_resa_internet_list_image_arriere_plan"))
        if (lstImage.length > 0) {
            var idxImage = Math.floor(Math.random() * lstImage.length)
            var urlFond = lstImage[idxImage]
        } else {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            var urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
        }
        return {
            url: urlFond,
            position: (parametre.isPhone ? "Gauche" : "Droite")
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            "1/reservation"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        //locationPathname=/nom_base/id_page/reservation
        return locationPathname.split("/")[2]
    }


    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}